import { Box } from "@chakra-ui/react";
import ContactForm from "./ContactForm";
import RetailerTrustStrip from "./RetailerTrustStrip";

const ContactSplit = () => (
  <Box
    as="section"
    bg="#f7fafc"
    px={{ base: "20px", md: "28px" }}
    pt={{ base: "48px", md: "64px" }}
    pb={{ base: "72px", md: "96px" }}
  >
    <Box maxW="720px" mx="auto">
      <ContactForm />
    </Box>

    <Box maxW="1280px" mx="auto" mt="64px">
      <RetailerTrustStrip />
    </Box>
  </Box>
);

export default ContactSplit;
